<template>
  <div>
    <el-dialog
      title="驳回原因"
      :visible.sync="show"
      class="top-draft-dialog app-examine-dialog"
      :before-close="handleClose"
    >
      <div class="card">
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <label>敏感词</label>
              <div class="label">
                {{ item.words || "无" }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div>
              <label>敏感图片</label>
              <div class="label mb-3" v-if="!item.sensitiveImages">无</div>
              <div class="sensitive-images mb-3" v-if="item.sensitiveImages">
                <img
                  @click="viewImage(url)"
                  v-for="(url, index) in item.sensitiveImages"
                  :src="`${url}`"
                  alt="加载失败"
                  :key="index"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- 审核拒绝需要显示拒绝理由 -->
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <label>驳回原因</label>
              <div v-if="item.rejectReason">
                <p>{{ item.rejectReason }}</p>
              </div>
              <div v-else>
                <p>无</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 审核拒绝需要显示拒绝理由结束 -->

        <div class="row submit-bar">
          <div class="col-md-12">
            <div class="bar-handle">
              <button
                @click="handleClose()"
                class="btn-sm btn btn-outline-dark"
                type="button"
              >
                关闭
              </button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      item: {},
      show: false
    };
  },

  props: {},

  mounted() {},

  methods: {
    showModel(item) {
      if (item) {
        let tabooList = false;
        if (item.taboo) {
          try {
            tabooList = JSON.parse(item.taboo);
            if (tabooList && tabooList.images.constructor === Array) {
              tabooList = tabooList.images;
            }
          } catch (e){
            tabooList = false;
          }
        }
        item.sensitiveImages = tabooList;
        this.item = item;
      }
      this.show = true;
    },

    handleClose() {
      this.show = false;
    },

    viewImage(url) {
      window.open(url, "_blank");
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>


























.app-examine-dialog .sensitive-images {
  width: 100%;
  display: inline;
  white-space: nowrap;
  overflow-x: scroll;
  float: left;
  overflow-y: hidden;
}

.app-examine-dialog .sensitive-images img {
  margin-right: 20px;
  display: inline-block;
  cursor: pointer;
  width: 250px;
  height: 140px;
}

.app-examine-dialog .sensitive-images img:last-child {
  margin-right: 0px;
}
</style>
